import {
  db,
  servicesCollection,
  usersCollection,
} from "../../../services/firebase";

export async function updateServicesWithRates(defaultGroups) {
  const servicesSnap = await servicesCollection.get();
  const batch = db.batch();

  servicesSnap.docs.forEach((docSnap) => {
    const svc = docSnap.data();
    // find the matching group by ID (coerce to string to be safe)
    const group = defaultGroups.find((g) => String(g.id) === String(svc.id));

    // build a new roles array: preserve id/name, but always add a `rate`
    const updatedRoles = svc.roles.map((role) => {
      const match = group?.roles?.find((r) => String(r.id) === String(role.id));
      return {
        ...role,
        rate: match ? match.rate : 0,
      };
    });

    // stage an update for this doc
    batch.update(docSnap.ref, { roles: updatedRoles });
  });

  // atomically commit all service‐doc updates in one go
  await batch.commit();
}

export async function updateUsersWithRates(defaultGroups) {
  const usersSnap = await usersCollection.get();
  const batch = db.batch();

  // build a flat map: roleName -> rate
  const roleRateMap = defaultGroups.reduce((map, group) => {
    group.roles.forEach((r) => {
      map[r.name] = r.rate;
    });
    return map;
  }, {});

  usersSnap.docs.forEach((docSnap) => {
    const data = docSnap.data();
    const userRole = data.role;
    if (userRole && roleRateMap[userRole] !== undefined) {
      // save rate as a string
      batch.update(docSnap.ref, { rate: String(roleRateMap[userRole]) });
    }
  });

  await batch.commit();
}
